// ==============================|| OVERRIDES - CSS BASELINE ||============================== //

export default function CssBaseline(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        // Very light purple body background
        body: {
          backgroundColor: '#fafaff'
        },
        // Transparent scrollbar with light purple color
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px'
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent'
        },
        '*::-webkit-scrollbar-thumb': {
          background: 'rgba(130, 94, 228, 0.15)',
          borderRadius: '10px',
          transition: 'background 0.3s ease'
        },
        '*::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(130, 94, 228, 0.3)'
        },
        // Firefox
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(130, 94, 228, 0.15) transparent'
        },
        // Remove border radius from AppBar
        '.MuiAppBar-root': {
          borderRadius: '0 !important'
        },
        // Stack DataGrid filter panel fields vertically on mobile only
        '@media (max-width: 599px)': {
          '.MuiDataGrid-filterForm': {
            flexDirection: 'column !important',
            alignItems: 'stretch !important',
            gap: '12px !important',
            padding: '16px !important',
            minWidth: '260px !important',
            boxSizing: 'border-box !important'
          },
          '.MuiDataGrid-filterForm .MuiFormControl-root': {
            width: '100% !important',
            minWidth: 'unset !important',
            maxWidth: '100% !important'
          },
          '.MuiDataGrid-filterForm .MuiInputBase-root': {
            width: '100% !important'
          }
        },
        // Landing page custom classes
        'main:has(.landing-wrapper)': {
          marginTop: '0 !important',
          padding: '0 !important',
          minHeight: '100vh !important'
        },
        '.landing-wrapper': {
          margin: 0,
          minHeight: '100vh',
          paddingTop: 0,
          position: 'relative'
        },
        '.landing-header': {
          background: 'linear-gradient(135deg, #7c5cdb 0%, #764ba2 100%)',
          padding: '16px 40px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          zIndex: 1300,
          borderRadius: '0 !important'
        },
        '.icon-circle': {
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          backgroundColor: '#ede7f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto',
          '& svg': {
            fontSize: '1.4rem',
            color: '#673ab7'
          }
        },
        // Force border radius on login button
        '.MuiButton-landing-login': {
          borderRadius: '8px !important',
          borderTopLeftRadius: '8px !important',
          borderTopRightRadius: '8px !important',
          borderBottomLeftRadius: '8px !important',
          borderBottomRightRadius: '8px !important'
        },
        '.landing-title-section': {
          paddingTop: '84px',
          paddingBottom: '32px',
          textAlign: 'center'
        },
        '.landing-link-wrapper': {
          display: 'flex',
          justifyContent: 'center',
          marginTop: '8px'
        },
        // Global styling for form/template selection cards
        '#each-form, #each-asset, #each-inspection': {
          position: 'relative',
          backgroundColor: '#fff !important',
          borderRadius: '12px !important',
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08) !important',
          transition: 'all 0.3s ease !important',
          overflow: 'hidden',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          minHeight: '120px',
          marginBottom: '20px !important',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap:'10px 10px' , 
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '12px 12px 0 0'
          },
         /* '&::after': {
            content: '"›"',
            position: 'absolute',
            right: '24px',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '2.5rem',
            color: '#667eea',
            fontWeight: 'bold',
            pointerEvents: 'none'
          },*/
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 24px rgba(102, 126, 234, 0.2) !important',
            borderColor: 'rgba(102, 126, 234, 0.3)',
            backgroundColor: '#fff !important'
          },
          '& .bg-light': {
            backgroundColor: 'transparent !important',
            padding: '28px 24px !important',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          },
          '& h5': {
            fontSize: '1rem !important',
            fontWeight: '600 !important',
            color: '#1a1a1a !important',
            textAlign: 'center !important',
            margin: '0 !important',
            padding: '0 50px 0 0 !important',
            lineHeight: '1.5 !important',
            wordWrap: 'break-word',
            width: '100%'
          }
        }
      }
    }
  };
}